import styled from 'styled-components'
import { CssUnit } from '@/types'
import { toUnit } from '@/utils/styles'

interface Props {
  gutter?: CssUnit
  color?: string
  alignContent?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'
  textAlign?: 'unset' | 'left' | 'center' | 'right'
  justify?: 'normal' | 'center'
  width?: CssUnit
  maxWidth?: CssUnit
  children: React.ReactNode
  className?: string
  top?: CssUnit
  flex?: string
}

const StackComponent = styled.div.withConfig<Omit<Props, 'children' | 'className'>>({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['width', 'color'].includes(prop) && defaultValidatorFn(prop)
})`
  --gutter: ${({ gutter }) => toUnit(gutter)};

  > * {
    margin: 0;
  }

  display: grid;
  gap: var(--gutter);
  padding-top: ${({ top }) => toUnit(top)};
  align-content: ${({ alignContent }) => alignContent};
  justify-items: ${({ justify }) => justify};
  text-align: ${({ textAlign }) => textAlign};
  width: ${({ width }) => toUnit(width)};
  max-width: ${({ maxWidth }) => (maxWidth !== 'unset' ? toUnit(maxWidth) : 'unset')};
  color: ${({ color }) => color || 'inherit'};
  flex: ${({ flex }) => flex};
`

const Stack: React.FC<Props> = ({
  gutter = 0,
  color,
  alignContent = 'start',
  textAlign = 'unset',
  justify = 'normal',
  width = 'auto',
  maxWidth = 'unset',
  children,
  top = 0,
  flex = 'unset',
  className
}) => {
  return (
    <StackComponent
      gutter={gutter}
      color={color}
      alignContent={alignContent}
      textAlign={textAlign}
      justify={justify}
      width={width}
      maxWidth={maxWidth}
      top={top}
      className={className}
      flex={flex}
    >
      {children}
    </StackComponent>
  )
}

export default Stack
